export default __webpack_public_path__ + "static/media/ferramenta-baixar-foto-img9.0592c7fb.jpeg";